// extracted by mini-css-extract-plugin
module.exports =  {"serviceCardContent":"rj8lI06j7hVpVdpz5M9w","serviceValue":"EV13QBSSsucma5ag9WCq"};